import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ABMModelos from './ABMModelos.jsx';
import * as actions from '../../actions/ABMModelosActions.js';

const mapStateToProps = (state) => {
    return {
        data: state.abmModelos,
        tarjetas: state.tarjetas
    }
}

const mapDispatchToProps = (dispatch) => {
    return { actions: bindActionCreators(actions, dispatch) }
}

//Connect entre el componente y las props y actions.
const ABMModelosContainer = connect(mapStateToProps, mapDispatchToProps)(ABMModelos);


export default ABMModelosContainer;